// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_mr-1";
export var rowFirst = "_mr-3";
export var rowLast = "_mr-5";
export var rowMiddle = "_mr-4";
export var ticketListScroll = "_mr-2";
export var ticketStack = "_mr-0";